
angular.module('trainerWebApp.controllers').controller('AddShopifyCoursesCtrl',
  ['$scope', '$rootScope', '$window', 'resolveData', 'mtypes', '$location', 'gridFormatters', 'Validation', '$routeParams', 'userGridUtils', 'accountFeatures', 'authView', 'shopifyResource', 'modalHelper', '$timeout', function ($scope, $rootScope, $window, resolveData, mtypes, $location, gridFormatters, Validation,
            $routeParams, userGridUtils, accountFeatures, authView, shopifyResource, modalHelper, $timeout) {

    // enforce catalog feature
    //if (!~accountFeatures.features.indexOf(mtypes.featureEntry.courseCatalog) && !authView.isActiveAdvancedtrial()) {
    //  $location.path('/TMS/Home');
    //  return;
    //}

    $window.document.title = "Add Shopify Content | Mindflash Training Management System";
    $rootScope.page = {name: 'addShopifyCourses', title: "addShopifyCourses"};

    var itemsToAdd = [];
    var dirtyItems = 0;
    var priceCell = 1;
    $scope.gridData = _.sortBy(resolveData.availableItems, function(item){ return (item.name || "").toLowerCase(); });
    disableEditForAllItem($scope.gridData);

    resolveData = null;
    $scope.viewModel = {
      selectedText: '',
      selectedData: [],
      addButtonState: {
        text: "Add to Shopify",
        enabled: false
      },
      oldSelectedRows: '',
      invalidPrice: ''
    };

    function getGridColumns() {
      return [
        {id: "price", name: "Price", field: "price", minWidth: 100, maxWidth: 100, cssClass: "cell-title", headerCssClass: "header-column-first", sortable: false, formatter: priceFormatter, editor: priceEditor},
        {id: "thumb", name: "", field: "thumb", width: 150, minWidth: 150, maxWidth: 150, cssClass: "cell-title", headerCssClass: "header-column", sortable: false, formatter: thumbFormatter},
        {id: "name", name: "Name", field: "name", maxWidth: 200, cssClass: "catalog-add-item-name", headerCssClass: "header-column-first", sortable: true},
        {id: "type", name: "Type", field: "type", maxWidth: 80, cssClass: "cell-title", headerCssClass: "header-column-first", sortable: true},
        {id: "description", name: "Description", field: "description", minWidth: 200,  cssClass: "slick-cell-wrap", headerCssClass: "header-column", sortable: false}
      ];
    }

    if (!$scope.gridCommands)
      $scope.gridCommands = {};
    var gridCommands = $scope.gridCommands;

    $scope.gridInfo = {
      options: {
        editable: true,
        enableCellNavigation: true,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.gridData.length < 500,
        multiColumnSort: true,
        rowHeight: 85,
        autoEdit: true,
        selectCheckboxClass: "slick-cell-checkboxsel-custom"
      },
      columns: getGridColumns(),
      onBeforeCellEditorDestroy: refreshAddContentButtonState,
      onBeforeEditCell: true,
      onSelectedRowsChanged: onSelectedRowsChanged,
      includeSelectCheckbox: true,
      checkboxSelectionFormatter: checkboxSelectionFormatter,
      filterFn: filterer,
      data: []
    };

    function onSelectedRowsChanged(args, value) {
      itemsToAdd = value;
      if(itemsToAdd.length === 0) {
        $scope.viewModel.selectedText = null;
      } else {
        var available = $scope.gridData.length;
        var selected = itemsToAdd.length;
        $scope.viewModel.selectedText = pluralize(available, 'item') + ' | ' + pluralize(selected, 'item') + ' selected | ';

        $scope.viewModel.selectedData = [];
        _.each(itemsToAdd, function(id){
          var gridItem = gridCommands.getItemById(id);
          if (gridItem) $scope.viewModel.selectedData.push(gridItem);
        });

        //enable edit
        var row = args.rows[args.rows.length-1];
        var previousId = value[value.length-1];
        var item = _.find($scope.gridData, function(data){
          return data.id == previousId;
        });
        item.disableEdit = false;

        $timeout(function(){
          gridCommands.gotoCell(row, priceCell, true);
        },0);
      }

      //Clear price on uncheck
      var currentSelectedRows = args.rows;
      var diff = _.difference($scope.viewModel.oldSelectedRows, currentSelectedRows);
      var diffItems = [];
      _.each(diff, function(index){
        diffItems.push(gridCommands.getItem(index));
      });
      if(diffItems.length > 0){
        clearPrice(diffItems);
      }

      $scope.viewModel.oldSelectedRows = args.rows;

      refreshAddContentButtonState();
    }

    function clearPrice(items){
      _.each(items, function(item){
        item.price = "";
        item.disableEdit = true;
        item.dirty = false;
        var row = gridCommands.getIdxById(item.id);
        gridCommands.updateCell(row, priceCell);
      });
    }

    function disableEditForAllItem(items){
      _.each(items, function(item){
        item.disableEdit = true;
      });
    }

    function pluralize(num, word) {
      if(num == 1) return num += ' ' + word;
      return num += ' ' + word + 's';
    }

    this.onSelectedRowsChanged = onSelectedRowsChanged;

    $scope.clearItems = function() {
      gridCommands.setSelectedRows([]);
    };

    function checkboxSelectionFormatter(row, cell, value, columnDef, item) {
      if (item && item.metaType != "" && item.metaType) return;

      var selectedRows = gridCommands.getSelectedRows();
      var checked = !!~selectedRows.indexOf(row);
      return checked ? "<input type='checkbox' checked='checked' class='catalog-add-item-cb'>" : "<input type='checkbox' class='catalog-add-item-cb'>";
    }

    function thumbFormatter(row, cell, value, columnDef, item) {
      return '<img class="catalog-item-thumbnail" src="' + item.thumbUrl + '"/>';
    }

    function priceFormatter(row, cell, value, columnDef, item) {
      var price = item.price ? isItemFloat(item) ? "$" + item.price : item.price : "--";
      var priceClass = (item.dirty && item.dirty == true) ? 'redPrice' : '';
      return '<span class="'+ priceClass + '">' + price + '</span>';
    }

    function priceEditor(args) {
      var priceField;
      var self = this;

      self.init = function () {
        $(args.container).append("$ ");

        if(args.item.dirty == true && args.item.price == 'Enter a price') args.item.price = '';

        priceField = $("<INPUT type=text style='width:60px' placeholder='0.00' />")
          .appendTo(args.container)
          .bind("keydown", self.handleKeyDown);

        self.focus();
      };

      self.handleKeyDown = function (e) {
        if(e.keyCode == $.ui.keyCode.LEFT || e.keyCode == $.ui.keyCode.RIGHT){
          e.stopImmediatePropagation();
        }
        else if (e.keyCode == $.ui.keyCode.TAB || e.keyCode == $.ui.keyCode.ENTER) {
          gridCommands.navigateLeft();
        }
      };

      self.destroy = function () {
        $(args.container).empty();
      };

      self.focus = function () {
        priceField.focus();
      };

      self.serializeValue = function () {
        return {price: priceField.val()};
      };

      self.applyValue = function (item, state) {
        item.price = state.price;
      };

      self.loadValue = function (item) {
        priceField.val(item.price);
      };

      self.isValueChanged = function () {
        return args.item.price != priceField.val();
      };

      self.validate = function () {
        return {valid: true, msg: null};
      };

      self.init();
    }

    function isItemFloat(item){
      return !isNaN(parseFloat(item.price));
    }

    $scope.addItemsToShopify = function () {
      //save active cell value
      var currentEditor = gridCommands.getCellEditor();
      if(currentEditor)
        gridCommands.getEditController().commitCurrentEdit();

      if (itemsToAdd.length === 0) return;
      $rootScope.$broadcast('$showLoadingSpinner', true);

      $scope.viewModel.addButtonState.enabled = false;
      var coursesToAdd = [];
      _.each($scope.viewModel.selectedData, function(data){
        coursesToAdd.push(_.pick(data, 'id', 'price'));
      });

      var data = {
        courses: coursesToAdd
      };
      shopifyResource.addItems(data, function(result) {
        var productsAddedLength = result.productsAdded.length;
        var selectedDataLength = $scope.viewModel.selectedData.length;
        if(selectedDataLength !== productsAddedLength){
          var selectedDataIds = _.pluck($scope.viewModel.selectedData, id);
          var productsAddedIds =  _.pluck(result.productsAdded, 'id');
          var contentDiff = _.difference(selectedDataIds, productsAddedIds);
          var errorData = [];
          _.each(contentDiff, function(errorId){
            errorData.push(_.findWhere($scope.viewModel.selectedData, {id: errorId}));
          });
          var errorTitles = _.pluck(errorData, 'name');
          var message = 'There was an error when trying to add ' + errorTitles.toString()  + ' to Shopify. Please try again.';
          modalHelper.messageBox({title: 'Error Adding Content', message: message, buttons: [{label: 'OK'}]});
        }
        $scope.viewModel.addButtonState.enabled = true;
        $location.path('/TMS/Shopify/');
        $rootScope.$broadcast('$showLoadingSpinner', false);
      }, function(err) {
        // something went wrong with the call
        $rootScope.$broadcast('$showLoadingSpinner', false);
        $scope.viewModel.addButtonState.enabled = true;
      });
    };

    function refreshAddContentButtonState() {
      $scope.viewModel.addButtonState.enabled = true;
      if(itemsToAdd.length <= 0)
        $scope.viewModel.addButtonState.enabled = false;
      else
        validation();

      buildAddButtonText();
    }

    var adding = false;

    function buildAddButtonText(){
      $scope.viewModel.addButtonState.text = adding ? "Adding... (" + $scope.viewModel.selectedData.length + ')' : itemsToAdd.length == 0 ? 'Add to Shopify' : 'Add to Shopify (' + itemsToAdd.length + ')';
    }

    $scope.$watch('shopifySearchCriteria', updateFilter);

    function updateFilter() {
      $scope.filterData = { nameCriteria: $scope.shopifySearchCriteria };
    }

    function filterer(itemToFilter, args) {
      if (!args || !args.nameCriteria) return true;
      return userGridUtils.filter.byName(itemToFilter, args.nameCriteria);
    }

    function validation(){
      if ($scope.viewModel.selectedData.length <= 0) return;

      dirtyItems = 0;
      _.each($scope.viewModel.selectedData, function(item){
        if(!isItemFloat(item)){
          item.dirty = true;
          item.price = "Enter a price";
          $scope.viewModel.addButtonState.enabled = false;
          dirtyItems++;
        }
        else{
          item.dirty = false;
          item.price = parseFloat(item.price);
        }
      });

      $scope.viewModel.invalidPrice = dirtyItems > 0 ? dirtyItems + ' item(s) need a valid price.' : '';
    }
  }]
);
